import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const BespokeSoftware = () => (
  <div className="service-page">
    <Navbar />
    <div className="service-hero">
      <h1>Bespoke Software</h1>
      <p>Tailor-made software solutions engineered to your exact business requirements — from concept and architecture through to deployment and ongoing support.</p>
    </div>

    <div className="service-content">
      <div className="service-grid">
        <div className="service-card">
          <div className="icon">🌐</div>
          <h2>Web Applications</h2>
          <p>
            We build responsive, performant web applications using modern frameworks and
            architectures. From single-page apps to complex enterprise portals, our solutions
            are scalable, secure, and user‑focused.
          </p>
          <ul>
            <li>React, Next.js &amp; Vue.js frontends</li>
            <li>Node.js, Python &amp; Go backends</li>
            <li>RESTful &amp; GraphQL API design</li>
            <li>Real-time features (WebSockets, SSE)</li>
            <li>Server-side rendering &amp; static generation</li>
            <li>Progressive web app (PWA) capabilities</li>
          </ul>
        </div>

        <div className="service-card">
          <div className="icon">📱</div>
          <h2>Mobile &amp; Cross-Platform</h2>
          <p>
            Reach users on every device with native-quality mobile applications built for
            iOS and Android. We use cross-platform toolkits to maximise code reuse without
            sacrificing performance.
          </p>
          <ul>
            <li>React Native &amp; Flutter development</li>
            <li>Native iOS (Swift) &amp; Android (Kotlin) when required</li>
            <li>Offline-first architecture with sync</li>
            <li>Push notifications &amp; deep linking</li>
            <li>Biometric authentication &amp; secure storage</li>
            <li>App Store &amp; Google Play publishing support</li>
          </ul>
        </div>

        <div className="service-card">
          <div className="icon">🔌</div>
          <h2>API &amp; Integration Layer</h2>
          <p>
            Connect your ecosystem. We design robust APIs and integration layers that
            enable seamless communication between your systems, partners, and third-party
            platforms.
          </p>
          <ul>
            <li>Custom REST &amp; GraphQL APIs</li>
            <li>Third-party platform integration (payment gateways, CRMs, ERPs)</li>
            <li>Legacy system modernisation &amp; API wrapping</li>
            <li>Event-driven architecture (Kafka, RabbitMQ, SQS)</li>
            <li>API gateway, rate-limiting &amp; documentation (OpenAPI/Swagger)</li>
            <li>Webhook management &amp; event subscriptions</li>
          </ul>
        </div>

        <div className="service-card">
          <div className="icon">⚙️</div>
          <h2>Enterprise Systems</h2>
          <p>
            Purpose-built enterprise software that automates workflows, centralises data,
            and empowers your teams with the tools they need to operate efficiently.
          </p>
          <ul>
            <li>Custom CRM, ERP &amp; workflow engines</li>
            <li>Dashboard &amp; business intelligence portals</li>
            <li>Document &amp; content management systems</li>
            <li>Role-based access control (RBAC) &amp; audit logging</li>
            <li>Multi-tenant architecture &amp; data isolation</li>
            <li>SSO, LDAP &amp; SAML integration</li>
          </ul>
        </div>

        <div className="service-card">
          <div className="icon">☁️</div>
          <h2>Cloud &amp; DevOps</h2>
          <p>
            We design and manage cloud infrastructure that is resilient, cost-effective,
            and ready to scale. Our DevOps practices ensure reliable deployments and
            rapid iteration cycles.
          </p>
          <ul>
            <li>Cloud architecture (AWS, GCP, Azure, DigitalOcean)</li>
            <li>Infrastructure as Code (Terraform, Pulumi, CDK)</li>
            <li>Container orchestration (Docker, Kubernetes, ECS)</li>
            <li>CI/CD pipeline setup (GitHub Actions, GitLab CI, ArgoCD)</li>
            <li>Monitoring, logging &amp; alerting (Prometheus, Grafana, ELK)</li>
            <li>Disaster recovery, backup &amp; high-availability design</li>
          </ul>
        </div>

        <div className="service-card">
          <div className="icon">🔒</div>
          <h2>Security &amp; Compliance</h2>
          <p>
            Security is built in from day one. Every solution follows industry best practices
            for data protection, access control, and regulatory compliance.
          </p>
          <ul>
            <li>Secure software development lifecycle (SSDLC)</li>
            <li>OWASP Top 10 mitigation &amp; secure coding standards</li>
            <li>Data encryption at rest &amp; in transit</li>
            <li>GDPR, POPIA, PCI-DSS &amp; SOC 2 compliance support</li>
            <li>Penetration testing &amp; vulnerability assessments</li>
            <li>Source code audits &amp; dependency scanning</li>
          </ul>
        </div>
      </div>
    </div>

    <div className="service-cta">
      <h2>Have a project in mind?</h2>
      <p>We turn ideas into production-grade software. Let's discuss your requirements.</p>
      <a href="mailto:kwuimi@qmxtechnology.com" className="cta">Start a Conversation</a>
    </div>

    <Footer />
  </div>
);

export default BespokeSoftware;
